const messages = {
  title: "Trgovina",
  description: "Dobrodošli v trgovino z nagradami. Tu lahko uveljavljate vaše Bridgestone Plus točke <br/> za nagrade iz različnih kategorij. Ponudba izdelkov <br/> se redno posodablja. Uživajte v brskanju.",
  sort: {
    asc: "Razvrsti po: Najnižja cena",
    desc: "Razvrsti po: Najvišja cena",
  },
  productSearchBox: {
    from: "točke od",
    to: "točke do",
  },
  noProducts: "Kriteriji iskanja niso dali rezultatov",
  quantity: "Količina",
  search: "Iskanje",
  perPage: "Elementov na stran",
  timeUnavailable: "Trenutno ni na voljo v tem trenutku",
  product: "Izdelek",
  cart: {
    pointsPerUnit: "Točke na enoto",
    pointsSum: "Vsota točk",
  },
  action: "Akcija",
  pointsTotal: "Skupaj",
  cartRemainPoints: "Preostale točke v košarici",
  shoppingCart: "Nakupovalna košarica",
  emptyCart: "Nakupovalna košarica je prazna.",
  attributes: "Atributi",
  selectAddressP: "Prosimo izberite vaš naslov za dostavo",
  orderDelivery: "Naslov za dostavo",
  selectedProducts: "Izbrani izdelki",
  orderSummary: "Pregled naročila",
  contactPerson: "Kontaktna oseba",
  selectedAddress: "Izbran naslov",
  order: {
    success: "Hvala! Vaše naročilo je bilo uspešno. Prejeli boste potrditev naročila v vaši prejeti pošti v nekaj minutah.",
    description: "Tu boste našli pregled vaših naročil iz trgovine z nagradami.",
    info: "Tu boste našli pregled vaših naročil iz trgovine z nagradami.",
    date: "Datum naročila",
    number: "Št. naročila",
    status: {
      created: "Ustvarjeno",
      confirm_order: "Potrdi naročilo",
      ready_for_shipment: "Pripravljeno za pošiljanje",
      rejected: "Zavrnjeno",
      processed: "Obrađeno",
      shipped: "Poslano",
      returned: "Vrnjeno",
      finished: "Zaključeno",
    },
    anyOrder: "Ni naročil",
    products: "Izdelki",
    quantity_short: "kos",
    itemRemoved: "ni mogoče dostaviti",
  },
  orders: "Naročila",
  notEnoughPoints: "Ni dovolj razpoložljivih točk.",
  statusText: "Stanje",
  outOfStock: "Trenutno ni na zalogi",
  productUnavailable: "Ta izdelek ni več na voljo.",
  deletedProductsTitle: "Izdelki niso več na voljo",
  deletedProductsMessage: "Naslednji izdelki niso več na voljo. Odstranite jih iz košarice, da nadaljujete.",
  removeSelected: "Odstrani izbiro",
  clearCart: "Izprazni košarico",
  removeSelectedConfirm: "Odstraniti izbrane izdelke iz košarice?",
  clearCartConfirm: "Odstraniti vse izdelke iz košarice?",
  incompleteAddress: {
    firstName: "Dodajte ime v naslov za dostavo",
    lastName: "Dodajte priimek v naslov za dostavo",
    company: "Dodajte ime podjetja v naslov za dostavo",
    street: "Dodajte ulico in hišno številko v naslov za dostavo",
    postalCode: "Dodajte poštno številko v naslov za dostavo",
    city: "Dodajte mesto v naslov za dostavo",
    country: "Dodajte državo v naslov za dostavo",
    phone: "Dodajte telefonsko številko v naslov za dostavo",
  },
  placeOrder: "Obvezujuća narudžba",
  toOrderDelivery: "Nastavi na adresu dostave",
  toOrderSummary: "Na pregled narudžbe",
  productImg: "Slika proizvoda",
  selectAddressBtn: "Odaberi adresu",
  perPgae: "Elementov na stran",
  categories: {
    advertising: {
      title: "Reklamni materijali",
      desc: "Sudjelujte izravno ovdje na platformi i osigurajte <br/> 40 dodatnih bodova za klub nagrada.",
    },
    rewards: {
      title: "Ekskluzivne nagrade",
      desc: "Otkrijte bonus ponudu u našem centru za obuku ili na vašoj lokaciji.",
    },
    tools: {
      title: "Alati za radionicu",
      desc: "Iskoristite bodove za obuke trećih strana <br/> i smanjite troškove.",
    },
    trainings: {
      title: "Obuke i tečajevi",
      desc: "Otkrijte bonus ponudu u našem centru za obuku ili na vašoj lokaciji.",
    },
    salesroom: {
      title: "Prodajni prostor",
      desc: "Uredite prodajni prostor i ponudite klijentima ugodan boravak.",
    },
    hunter: {
      title: "Hunter",
      desc: "Zamijenite bodove za atraktivnu opremu radionice Hunter.",
    },
  },
  bestSold: "Najprodavanije",
  seasonal: "Sezonsko",
  affordable: "Skoro gotovo",
  forPoints: "za {points} bodova",
  reachedPoints: "Potrebni bodovi postignuti",
  remainingPoints: "Nedostaje {points} bodova",
  favoriteProducts: {
    description: "Tu boste našli shranjene izdelke.",
  },
  categoryPageDescriptionFallback: "Material za delavnico ali drugi kakovostni izdelki z logotipom Bridgestone za vaše podjetje",
  variant: "Izberljive različice",
};
export default {
  messages,
};
